export function setExtraFormData(data) {
  return Object.keys(data).reduce((result, key) => result + `${key}: ${data[key]}\n`, '');
}

export function isValidEmail(value) {
  const email = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
  return email.test(value);
}

export default {
  setExtraFormData,
  isValidEmail
};



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/utils.js